const redux = require('redux')

const initialState = ''

// Reducer 
const rootReducer = (state = initialState, action) => {
    switch(action.type){
        case "USER_LOGIN":
            return {
                state : action.newData, route: 'Home'
            }
        case "USER_LOGOUT":
            
            return {
                state : '', route: 'Home'
            }
        case "ROUTE_CALENDAR":
            return {
                ...state,route:'Calendar'
            }
        default:
            return state;
    }
}

// Store 
const store = redux.createStore(rootReducer);
export default store;

// Subcription 
// store.subcription( () => {
//     console.log('Store Change: ', store.getState())
// store.subscribe(() => 
//   console.log(store.getState())
// )

// Dispatching Action
// store.dispatch({type:'GET_USER', newData: 10})